var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.084,
    height: 27.084,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.317 9.479H6.771a1.354 1.354 0 110-2.708h13.546a1.354 1.354 0 010 2.708zm0 5.417H6.771a1.354 1.354 0 110-2.708h13.546a1.354 1.354 0 010 2.708z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4879f9",
    d: "M23.021 0H4.063A4.067 4.067 0 000 4.063V17.6a4.067 4.067 0 004.063 4.063h15.69l5.02 5.02a1.354 1.354 0 002.312-.957V4.063A4.067 4.067 0 0023.021 0zm-2.708 14.9H6.771a1.354 1.354 0 010-2.708h13.542a1.354 1.354 0 110 2.708zm0-5.417H6.771a1.354 1.354 0 010-2.708h13.542a1.354 1.354 0 110 2.708z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chatBubble.108fd1efdb10a9a2e71812b2a46a1dfa.svg";
export { ForwardRef as ReactComponent };